import { css, keyframes } from "styled-components";

// Common UI Library Styles

export const boxShadowDs1 = css`
  box-shadow: 0px 0px 8px 4px rgb(0 0 0 / 4%);
`;

export const boxShadowDs2 = css`
  box-shadow: 0px 0px 8px 4px rgb(0 0 0 / 8%);
`;

export const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;
